// weex运行环境变量
import M_ENV from '../../../main/components/env/index.js'
import M_TOOLKIT from '../../../main/components/toolkit/index.js'

// 内部私有对象不对外抛出，
const _bridge = {

    // 调用weexbridge
    callWeexBridge: function (method, options) {
        let _method = method
        let _options = options

        _method = 'invokeJSAPI'
        _options = {
            params: {
                methodName: method,
                parameter: options.params
            },
            callback: options.callback || (() => {})
        }

        return _weex_bridge.invoke(_method, _options)
    },

    // 调用webbridge
    callWebBridge: function (method, options) {
        
        if (typeof options != 'undefined') {
            if (M_TOOLKIT.isFunction(options.callback)) {
                // 入参有回调，则拓展option参数，传入callbackName
                let callback_name = _web_bridge.callbackHandle(method, options)
                options = M_TOOLKIT.extend(options, {
                    callBackName: callback_name
                })
            }
        }
        return _web_bridge.invoke(method, options)
    }

}

const _weex_bridge = {
    /** *
     * @function invoke
     * @descrition [调用APP接口, 不对外暴露]
     * @param {String} method_fun 调用的接口名[必选]
     * @param  {Object} options  调用接口传入的参数[可选]
     */
    invoke: function (method_fun, options) {
        try {
            let method = method_fun || ''
            let event = weex.requireModule('event')
            
            if (event[method] && M_TOOLKIT.isFunction(event[method])) {
                // 判断入参是否为对象
                let params = options.params
                let is_object = M_TOOLKIT.isObject(params)
                
                params = is_object ? JSON.stringify(params) : params
    
                // 判断入参是否存在回调函数，若存在回调函数，需要对部分返回data类型为字符串的数据进行数据类型转化
                let return_callback = options.callback && M_TOOLKIT.isFunction(options.callback) ? options.callback : ''
                let params_callback = () => {}
                
                if (return_callback) {
                    params_callback = (data) => {
                        // 若为对象直接调用
                        if (M_TOOLKIT.isObject(data)) {
                            return_callback(data)
                        } else { // 返回字符串则做eval解析
                            let json = data ? eval( '(' + data + ')' ) : ''
                            
                            return_callback(json)
                        }
                    }
                }
                
                // 检查入参及回调函数
                if (params && return_callback) {
                    event[method](params, params_callback)
                } else if (params) {
                    event[method](params)
                } else if (return_callback) {
                    event[method](params_callback)
                } else {
                    event[method]()
                }
            }
        } catch (error) {
            // console.error(error)
        }

    }
}

const _web_bridge = {
    cbPrefix: 'FQL_JSBridge_Cb_',
    retPrefix: 'FQL_JSBridge_Rt_',
    /**
     * @function callbackHandle
     * @description [接口回调函数处理]
     * @param {String} method_name 函数名
     * @param {object} options 入参
     * @return {String} 传给接口的回调函数名
     */
    callbackHandle: function (method_name, options) {
        // 获取传给接口的回调函数名
        var callback_name = this.getCallbackName(method_name)

        // 如果有传回调函数，则将其扩展到window，给客户端调用
        if (M_TOOLKIT.isFunction(options.callback)) {
            this.setCallback(callback_name, options.callback, function (res) {
                if (typeof res == 'object') { // ios会返回json对象
                    options.callback(res)
                } else { // android返回返回字符串，但是要针对低版本的app返回不标准的字符串做转换
                    res = res || '{}'
                    var json = eval('(' + res + ')')
                    options.callback(json)
                }
            })
        } else {
            top[callback_name] = function () {}
        }

        // 返回callback_name
        return callback_name
    },
    /**
     * @function getCallbackName
     * @description [获取注册到window的方法名]
     * @param {string} method_name 方法名称[必选]
     * @param {string} bridge_name bridge名称[必选]
     * @return {string} 回调名
     */
    getCallbackName: function (method_name, bridge_name) {
        bridge_name = bridge_name || ''
        bridge_name = bridge_name && (bridge_name + '_')
        return this.cbPrefix + bridge_name + method_name
    },
    /**
     * @function setCallback
     * @description [将回调函数注册到window]
     * @param {String} method_name 函数名[必选]
     * @param  {Function} callback  回调函数
     * @param  {Function} before_callback  回调函数执行前执行的回调，用于封装app返回的数据
     */
    setCallback: function (method_name, callback, before_callback) {
        if (M_TOOLKIT.isFunction(before_callback)) {
            top[method_name] = before_callback
        } else {
            top[method_name] = callback
        }
    },
    /** *
     * @function invoke
     * @descrition [调用APP接口, 不对外暴露]
     * @param {String} method 调用的接口名[必选]
     * @param  {Object} options  调用接口传入的参数[可选]
     */
    invoke: function (method, options) {
        let ret = null
        let _this = this

        _this.ready(function () {
            if (_this.isIosV2Invok()) { // 分期乐ios app中调用JSAPI接口
                if (!M_TOOLKIT.isPlainObject(options)) {
                    options = {}
                }
                try {
                    // 生成临时字段，用于操作options
                    let tem = options.params

                    // 删除options的params层级
                    if (options.params) {
                        delete options.params
                    }

                    // 切成invokeJSAPI方式
                    let params = {
                        methodName: method,
                        parameter: {...options, ...tem}
                    }
                    top.webkit.messageHandlers.FQL_JSBridge.postMessage({
                        funcName: 'invokeJSAPI',
                        parameter: JSON.stringify(params) // 参数转成字符串
                    })
                } catch (e) {
                    console.error(e.message)
                    
                }
            } else { // 分期乐android app中调用JSAPI接口
                // 生成临时字段，用于操作options
                let tem = options.params

                // 删除options的params层级
                if (options.params) {
                    delete options.params
                }

                // 切成invokeJSAPI方式
                let params = {
                    methodName: method,
                    parameter: {...options, ...tem}
                }

                top.FQL_JSBridge['invokeJSAPI'](JSON.stringify(params))
            }

            return ret
        })
    },
    /**
     * @function isIosV2Invok
     * @description [是否采用iOS第二版JSAPI调用方式]
     * @example
     * var ret = AppBridge.invokeJsBridge('isIosV2Invok');
     */
    isIosV2Invok: function () {
        let ua = navigator.userAgent
        let patt = /wv_i_v2/i
        let res = patt.exec(ua)
        
        return !!res
    },

    isReady: function () {
        if (M_ENV.isWebInAndroid) { // 非ios，直接返回true
            return true
        }

        let is_ready = false

        if (this.isIosV2Invok()) { // ios v2 webview
            try {
                if (!!top.webkit && !!top.webkit.messageHandlers && top.webkit.messageHandlers.FQL_JSBridge && !!top.webkit.messageHandlers.FQL_JSBridge.postMessage) {
                    is_ready = typeof top.webkit.messageHandlers.FQL_JSBridge.postMessage === 'function'
                } else {
                    is_ready = false
                }
            } catch (e) {
                is_ready = false
            }
        } else { // ios v1 webview
            is_ready = typeof top.FQL_JSBridge !== 'undefined'
        }
        return is_ready
    },

    /**
     * @function ready
     * @description [jsBridge初始化完成事件回调]
     * @param  {Function} callback  回调函数
     */
    ready: function (callback) {
        // 如果不是函数则直接返回
        if (!M_TOOLKIT.isFunction(callback)) {
            return false
        }
        if (this.isReady()) { // 已经ready
            // 在app中才触发回调
            if (M_ENV.isWebInApp || M_ENV.isSdk) {
                callback()
            }
        } else { // 还没有ready
            // 如果jsBridge还没注入，则监听FQL_JSBridgeReady事件
            top.document.addEventListener('FQL_JSBridgeReady', function (event) {
                setTimeout(function () {
                    callback()
                }, 0)
            }, false) // 绑定监听器
        }
    },

    /**
     * @function getCallbackName
     * @description [获取注册到window的方法名]
     * @param {string} methodName 方法名称[必选]
     * @param {string} bridgeName bridge名称[必选]
     */
    getCallbackName: function (methodName, bridgeName) {
        bridgeName = bridgeName || ''
        bridgeName = bridgeName && (bridgeName + '_')
        return this.cbPrefix + bridgeName + methodName
    },

    /**
     * @function setCallback
     * @description [将回调函数注册到window]
     * @param {String} methodName 函数名[必选]
     * @param  {Function} callback  回调函数
     * @param  {Function} beforeCallback  回调函数执行前执行的回调，用于封装app返回的数据
     */
    setCallback: function (methodName, callback, beforeCallback) {
        if (M_TOOLKIT.isFunction(beforeCallback)) {
            top[methodName] = beforeCallback
        } else {
            top[methodName] = callback
        }
    }
}

/**
 * weexBridge及webBridge统一收拢，对外提供接口进行调用，外部无需感知weex api及web js api底层逻辑
 * @description [注释中native表示基于weex的ios及Android端]
 * @description [G_BRIDGE只做接口区分bridge调用，不做任何版本兼容，平台兼容逻辑，版本兼容及平台兼容统一在weexBridge或者webBridge处理]
 */
const G_BRIDGE = {
    invoke: (method, options) => {
        // weex调用方式
        if (M_ENV.isWeexNativeInApp) {
            _bridge.callWeexBridge(method, options)
        }
        // web在app中的调用方式
        else if (M_ENV.isWebInApp) {
            _bridge.callWebBridge(method, options)
        }
    }
}

export default G_BRIDGE